import React from 'react';
export function ProofBar() {
  const logos = ['Slack', 'Gmail', 'Google Ads', 'Meta', 'Salesforce', 'HubSpot', 'Stripe', 'QuickBooks', 'Twilio', 'Zapier', 'Calendly', 'Shopify'];
  return <section className="bg-dark-bg py-12 border-y border-white/10 overflow-hidden relative" data-id="element-903">
      <div className="max-w-7xl mx-auto px-6 mb-6 text-center" data-id="element-904">
        <p className="font-poppins font-semibold text-sm tracking-wider uppercase text-steel" data-id="element-905">
          MISTR connects to your entire world.
        </p>
      </div>

      {/* Gradient Fade Edges */}
      <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-dark-bg to-transparent z-10 pointer-events-none" data-id="element-906" />
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-dark-bg to-transparent z-10 pointer-events-none" data-id="element-907" />

      {/* Infinite Scroll Container */}
      <div className="relative flex overflow-x-hidden group" data-id="element-908">
        <div className="animate-marquee flex whitespace-nowrap items-center" data-id="element-909">
          {[...logos, ...logos].map((logo, index) => <div key={index} className="mx-8 text-2xl font-poppins font-bold text-white hover:text-purple transition-colors duration-300 cursor-default" data-id="element-910">
              {logo}
            </div>)}
        </div>
      </div>

      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
        .group:hover .animate-marquee {
          animation-play-state: paused;
        }
      `
    }} data-id="element-911" />
    </section>;
}